import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';

const SecurityPopup = ({ user, onContinue }) => {
  const navigate = useNavigate();
  const [ultimoAcesso, setUltimoAcesso] = useState(null);

  useEffect(() => {
    // Carregar informações do último acesso ANTERIOR (antes do login atual)
    const loginAnterior = localStorage.getItem('loginAnterior');
    if (loginAnterior) {
      const dadosAnterior = JSON.parse(loginAnterior);
      setUltimoAcesso({
        ip: dadosAnterior.ip,
        data: dadosAnterior.data
      });
    } else {
      // Se não houver login anterior, buscar do user atual (primeiro acesso)
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        setUltimoAcesso({
          ip: userData.ultimo_ip_login,
          data: userData.ultimo_login_at
        });
      }
    }
  }, []);

  const handleContinue = () => {
    // Limpar flag do popup
    localStorage.removeItem('showSecurityPopup');
    if (onContinue) {
      onContinue();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="security-popup-overlay">
      <div className="security-popup-content">
        <div className="security-popup-header">
          <span className="success-icon">✅</span>
          <h2>Login Realizado com Sucesso!</h2>
          <p>Bem-vindo(a), {user?.nome || 'Usuário'}</p>
        </div>

        <div className="security-info-box">
          <h3>
            🔒 Informações de Segurança
          </h3>
          <div className="security-info-item">
            <span className="security-info-label">🌐 Último IP:</span>
            <span className="security-info-value">
              {ultimoAcesso?.ip || 'Primeiro acesso'}
            </span>
          </div>
          <div className="security-info-item">
            <span className="security-info-label">📅 Último Acesso:</span>
            <span className="security-info-value">
              {ultimoAcesso?.data 
                ? new Date(ultimoAcesso.data).toLocaleString('pt-BR')
                : 'Primeiro acesso'}
            </span>
          </div>
        </div>

        <div className="security-warning">
          <p>
            <strong>⚠️ Atenção:</strong> Se você não reconhece este acesso ou o IP acima, 
            altere sua senha imediatamente e contate o administrador do sistema.
          </p>
        </div>

        <button 
          onClick={handleContinue}
          className="btn-continue"
        >
          Continuar →
        </button>
      </div>
    </div>
  );
};

export default SecurityPopup;
